import React from 'react'
import {Link} from 'react-router-dom'
import './index.css'

const NotFound = () => (
  <div className="notfound-page">
    <header className="nf-header">
      <Link to="/">
        <img
          src="https://assets.ccbp.in/frontend/react-js/tech-era/website-logo-img.png"
          alt="website logo"
          className="logo"
        />
      </Link>
    </header>

    <main className="nf-content">
      <img
        src="https://assets.ccbp.in/frontend/react-js/tech-era/not-found-img.png"
        alt="not found"
        className="nf-image"
      />
      <h1>Page Not Found</h1>
      <p>We are sorry, the page you requested could not be found.</p>
      <Link to="/" className="home-button">
        Home
      </Link>
    </main>
  </div>
)

export default NotFound
